import React, { useState } from "react";
import DownloadLogsComponent from "../components/DownloadLogs";
import DownloadDeliveryLogs from "../components/Delivery";

const DownloadDeliveryLogsComponent = () => (
	<div className='p-4'>This is the Download Delivery Logs component.</div>
);

const Logs = () => {
	const [activeTab, setActiveTab] = useState("logs");

	return (
		<div className='p-4'>
			<h1 className='text-xl font-semibold mb-4'>SMS Logs</h1>

			<div className='flex space-x-4 border-b mb-4'>
				<button
					onClick={() => setActiveTab("logs")}
					className={`px-4 py-2 font-medium ${
						activeTab === "logs"
							? "border-b-2 border-blue-600 text-blue-600"
							: "text-gray-600"
					}`}
				>
					Download Logs
				</button>
				<button
					onClick={() => setActiveTab("deliveryLogs")}
					className={`px-4 py-2 font-medium ${
						activeTab === "deliveryLogs"
							? "border-b-2 border-blue-600 text-blue-600"
							: "text-gray-600"
					}`}
				>
					Download Delivery Logs
				</button>
			</div>

			{activeTab === "logs" && <DownloadLogsComponent />}
			{activeTab === "deliveryLogs" && <DownloadDeliveryLogs />}
		</div>
	);
};

export default Logs;
